<script>
export default {
  name: "ReverseDischargeForm",

  data() {
    return {
      memo: ``,
      wards: [],
      beds: [],
      reverse: {
        packageId: 0,
        wardId: 0,
        bedId: 0,
        special: false,
      },
    };
  },

  props: {
    showModal: Boolean,
    patient: Object,
    packages: Array,
  },

  watch: {
    showModal() {
      if (this.showModal) return;

      this.memo = ``;
    },

    "reverse.packageId"() {
      if (!this.reverse.packageId) return;

      this.fetchWards();
    },

    "reverse.wardId"() {
      if (!this.reverse.wardId) return;

      this.fetchBeds();
    },
  },

  methods: {
    fetchWards() {
      this.$root.loading = true;
      let url = `Admissions/GetWards`;
      url += `?PackageID=${this.reverse.packageId}`;
      this.$http
        .get(url)
        .then(({ data }) => {
          this.wards = data;
          this.$root.loading = false;
        })
        .catch(() => {
          this.$root.loading = false;
        });
    },

    fetchBeds() {
      this.$root.loading = true;
      let url = `Admissions/GetBeds`;
      url += `?WardId=${this.reverse.wardId}`;

      this.$http
        .get(url)
        .then(({ data }) => {
          this.beds = data;
          this.$root.loading = false;
        })
        .catch(() => {
          this.$root.loading = false;
        });
    },

    reverseDischarge() {
      if (!this.patient.patientID && !this.patient.visitNo) return;

      if (!window.confirm(`Confirm reverse discharge`)) return;

      this.$root.loading = true;
      const reverse = {
        patientID: this.patient.patientID,
        visitNo: this.patient.visitNo,
        patientName: this.patient.names,
        memo: this.memo,
        userName: this.$root.username,
        bedID: this.reverse.bedId,
        special: this.reverse.special,
        date: window.moment().format(`YYYY-MM-DD`),
      };

      this.$http
        .post(`Admissions/ReversePatientDischarge`, reverse)
        .then(({ data }) => {
          this.$emit(`resetPatient`);
          this.$emit(`refresh`);
          this.reverse = {
            packageId: 0,
            wardId: 0,
            bedId: 0,
            special: false,
          };
          this.memo = ``;
          this.$root.loading = false;
          this.$emit(`closeModal`);
          window.Swal.fire({ type: `success`, text: data });
        })
        .catch(() => {
          this.$root.loading = false;
        });
    },
  },
};
</script>
<template>
  <tail-modal :show="showModal" dimension="md:w-1/2 w-3/4">
    <template v-slot:title>
      <h5 class="font-medium text-sm">Reverse Discharge</h5>
    </template>
    <template v-slot:modal-body>
      <div class="w-full flex flex-wrap items-center">
        <div
          class="w-full flex flex-wrap border-2 border-gray-400 mb-2 rounded-t-md"
        >
          <div class="w-full p-1 bg-gray-400 rounded-t-md">
            <h5 class="font-medium text-sm">Patient Details</h5>
          </div>
          <div class="w-full p-1">
            <h5 class="font-bold text-sm">Name: {{ patient.names }}</h5>
          </div>
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-bold text-sm">MRN: {{ patient.patientID }}</h5>
          </div>
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-bold text-sm">IP: {{ patient.ipfileno || `-` }}</h5>
          </div>
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-bold text-sm">OP: {{ patient.opfileno || `-` }}</h5>
          </div>
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-bold text-sm">
              Package: {{ patient.bed_Type || `-` }}
            </h5>
          </div>
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-bold text-sm">Ward: {{ patient.ward || `-` }}</h5>
          </div>
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-bold text-sm">Bed: {{ patient.bed || `-` }}</h5>
          </div>
        </div>
        <div class="w-full flex flex-wrap p-1">
          <div class="w-full md:w-1/3 p-tiny">
            <label for="grid-package" class="label-control">Package:</label>
            <tail-select>
              <template v-slot:field>
                <select
                  v-model="reverse.packageId"
                  id="grid-package"
                  class="input-control input-sm text-xs"
                >
                  <option :value="0">Select package</option>
                  <option
                    v-for="pack in packages"
                    :key="`__${pack.id}`"
                    :value="pack.id"
                  >
                    {{ `${pack.type} - ${pack.dailyCharge}` }}</option
                  >
                </select>
              </template>
            </tail-select>
          </div>
          <div class="w-full md:w-1/3 p-tiny">
            <label for="grid-ward" class="label-control">Ward:</label>
            <tail-select>
              <template v-slot:field>
                <select
                  id="grid-ward"
                  v-model="reverse.wardId"
                  class="input-control input-sm text-xs"
                >
                  <option :value="0">Select ward</option>
                  <option
                    v-for="(ward, idx) in wards"
                    :key="`_${ward.wardID}_${idx}`"
                    :value="ward.wardID"
                  >
                    {{ ward.ward }}
                  </option>
                </select>
              </template>
            </tail-select>
          </div>
          <div class="w-full md:w-1/3 p-tiny">
            <label for="grid-bed" class="label-control">Bed:</label>
            <tail-select>
              <template v-slot:field>
                <select
                  id="grid-bed"
                  v-model="reverse.bedId"
                  class="input-control input-sm text-xs"
                >
                  <option :value="0">Select Bed</option>
                  <option
                    v-for="bed in beds"
                    :key="bed.bedID"
                    :value="bed.bedID"
                    >{{ bed.bed }}</option
                  >
                </select>
              </template>
            </tail-select>
          </div>
          <div class="md:w-1/3 w-full p-1" v-if="$root.checkAuth(`ConvertPatientToSpecial`)">
            <label for="grid-special" class="font-medium text-xs text-gray-700">
              <input type="checkbox" v-model="reverse.special" id="grid-special"> Special</label>
          </div>
          <div class="w-full p-tiny">
            <label for="grid-memo" class="label-control">Memo:</label>
            <textarea
              id="grid-memo"
              cols="30"
              rows="2"
              v-model.trim="memo"
              class="input-control input-sm text-xs"
            ></textarea>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <button
        class="btn-danger btn-sm text-xs rounded mr-6"
        @click.prevent="$emit(`closeModal`)"
      >
        <i class="fa fa-times"></i> Close
      </button>
      <button
        @click.prevent="reverseDischarge"
        class="btn-primary btn-sm text-xs rounded"
      >
        <i class="fa fa-undo"></i> Reverse Discharge
      </button>
    </template>
  </tail-modal>
</template>
